import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { FuseConfirmationService } from '@fuse/services/confirmation/confirmation.service';

@Injectable({
  providedIn: 'root'
})
export class ConfirmNavigationGuard implements CanDeactivate<any> {
  constructor(private confirmationService: FuseConfirmationService) {}

  canDeactivate(component: any): Observable<boolean> {
    if (component['hasUnsavedChanges']()) {
      return new Observable<boolean>(observer => {
        this.confirmationService.open({
          message: 'Êtes-vous certain de vouloir quitter la page? Vous avez des changements qui n\'ont pas été sauvegardé.',
          actions: {
            confirm: {
              show: true,
              label: 'Oui, je confirme',
              color: 'warn',
            },
            cancel: {
              show: true,
              label: 'Non, je veux rester',
            }
          },
          dismissible: false
        }).afterClosed().subscribe(result => {
          if (result === 'confirmed') {
            observer.next(true);  // Allow navigation
          } else {
            observer.next(false);  // Prevent navigation
          }
          observer.complete();
        });
      });
    }

    // If no unsaved changes, allow navigation
    return new Observable<boolean>((observer) => {
      observer.next(true);
      observer.complete();
    });
  }
}